import $ from 'jquery';
import React from 'react';
import QueryString from 'query-string';
import Chart from "react-google-charts";
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {CallMapMethod, GetDateDifferecec,CallMapMethod_CBack,_getInitParam} from '../function_lib/common_lib';
import Header from './header';
import Footer from './footer';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Upcoming_Events from '../components/upcoming_events';
import Emp_On_Leave from '../components/emp_on_leave';
import Broadcast from '../components/broadcast';
import Mobile_Widgets from '../components/mobile_widgets';
import {LineChart,BarChart,Comparison_BarChart,Top_Overall_BarChart} from '../components/graphical_reports';
import {Comp_Map_Marker} from '../components/comp_map_marker';
// import Comp_Dashboard_Castrol from '../korbyt/comp_dashboard_castrol';

import Comp_Box_Div from "../korbyt/comp_box_div";
import Comp_Live_Fetching from "../korbyt/comp_live_fecthing";
import Comp_oil_changes from "../korbyt/comp_oil_changes";
import "../korbyt/comp_dashboard_castrol.css";
import Comp_Map_Circles from "../korbyt/comp_map_cirle";
import Comp_Slider_Box from "../korbyt/comp_slider_box";

import castrol1 from '../assets/images/sm_castrol1.jpg';

import './dashboard_new.css';

//import UserManual from '../assets/Operational_Instructions.pdf';

let loginUser="";
let userObject="";
let companyName="";
let userType="";
let clsDashboardNew;

let _chkOrderCall=false;
let _chkAnalyticsCall=false;
let _chkCmsCall=false;
let _initSettings={};
const refreshInterval = 15 * 60 * 1000; // 15 minutes in ms
let nextRefreshTime = Date.now() + refreshInterval;

let rf="0";
let queries;
class Castrol_Dashboard extends React.Component{
    forceUpdateHandler(){
        this.forceUpdate();
      };
    constructor(props){
        super(props);
        clsDashboardNew=this;
        _initSettings=_getInitParam();
        //alert(JSON.stringify(_initSettings.app_settings.settings.dashboard));
        _initSettings=_initSettings.app_settings.settings.dashboard;
        this.state={stWeekOilChangeCount:[],creditBalance:[],stCurrentMonthOilChange_V:[]
          ,stTillDateTo:[],stMachineCounts:[]
        ,stQlcList:[],stQulcActive:"0",stLiveTicker:[]};
        //this.state={no_entities:0,no_clients:0,no_vendors:0}
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        userType="0";
        
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      if(props !=null){
        queries = QueryString.parse(this.props.location.search);
              if(queries.rf!=null){
                rf=queries.rf;
              }
      }

      let ret= getAccessFunctions();
      //alert(ret);
     
    }
   
getDashBoardPerfo(){
  if(rf==="0"){
    alert("invalid token, kindly reload again");
    return;
  }
  var map=[];
  map.push({name:"curl_type",value:"getGraphDataReport"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"local_token",value:rf});
  map.push({name:"gb_token",value:rf});
  //map.push({name:"acc_inf_id",value:userObject[0].app_user_id});
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getGraphDataReport";

  CallMapMethod_CBack(clsDashboardNew,map,function(data,msg){
    
    if(data!=="0" && data!==""){
      let jsData=JSON.parse(data);
      
      
    
      
//alert(JSON.stringify(jsData["qlc_active_counts"]));
      

      clsDashboardNew.setState({      
        
      stCurrentMonthOilChange_V:jsData["current_month"],
        stMachineCounts:jsData["machine_counts"],
        stQlcList:jsData["qlc_list"],
        stQulcActive:jsData["qlc_active_counts"],
        stWeekOilChangeCount:jsData["this_week"],
        stLiveTicker:jsData["ticker_data"]
      });

    }
  })

}
// Show countdown in "MM:SS" format
updateTimerDisplay() {
  const now = Date.now();
  let diff = Math.max(0, Math.floor((nextRefreshTime - now) / 1000)); // in seconds

  const minutes = Math.floor(diff / 60);
  const seconds = diff % 60;

  document.getElementById("count_notification_kor").innerText =
    `Next refresh in ${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;

  // If reached 0, schedule next refresh
  if (diff <= 0) {
    nextRefreshTime = Date.now() + refreshInterval; // reset for next cycle
  }
}

      componentDidMount(){
        
        this.getDashBoardPerfo();
        $("#divEmployee").show();
        this.forceUpdateHandler();

        // Set refresh interval (15 minutes in ms)

        const refreshInterval = 15 * 60 * 1000; // 15 minutes in ms
let nextRefreshTime = Date.now() + refreshInterval;
setInterval(this.updateTimerDisplay, 1000);

this.dashboardInterval = setInterval(() => {
  this.getDashBoardPerfo();
  nextRefreshTime = Date.now() + refreshInterval; // sync countdown with actual refresh
}, refreshInterval);
      }

      componentWillUnmount() {
        // Clear the interval to prevent memory leaks
        //clearInterval(this.dashboardInterval);
    }
   //Get no of Entities/Client/Vendos
     
   
     

    render(){
        return(
        
        
        <div className="wrapper">
       
        
        
            {/* <Header/> */}

          

            {/* <Mobile_Widgets/> */}
            <div class="content" style={{"min-height":"150px"}}>
            <div class="container-fluid mt-4">
                   {/* new acta component */}
                   <div className="row">
                    <div className="col-md-12">
                      
                      {/* New Dashboard  */}

                      <div class="castrol-dashboarddd container-fluid px-4 py-4">
      <div class="row g-4">
        {/* Left Section */}
        <div class="col-lg-8">
          {/* <div class="row g-4"> */}
            <div class="dashboard-card h-100">
              <div class="status-header">
                {/* <i class="fas fa-cog fa-spin"></i> */}
                <i class="fa fa-area-chart fa-3x white"></i>
                <h2>Express Network</h2>
              </div>
              <div class="card-body p-0">
                <div id="map">
                <Comp_Map_Marker qlcList={this.state.stQlcList}/>
                  {/* <Comp_Map_Circles /> */}
                </div>
              </div>

              {/* Live Activity + Progress */}
              <div class="row g-4 mt-2">
                  <div class="col-md-6">
                  {/* <Comp_Bar_Progress_Box /> */}
                  <Comp_oil_changes percentage={this.state.stWeekOilChangeCount.length>0?this.state.stWeekOilChangeCount[0]["count_cc"]:0}/>
                </div>
                <div class="col-md-6">
                  <Comp_Live_Fetching  />
                </div>
              </div>
            </div>
          {/* </div> */}
        </div>

        {/* Right Section */}
        <div class="col-lg-4">
          <div class="row g-4">
            <div class="col-12">
              <Comp_Box_Div  currentMonthOilChange_V={this.state.stCurrentMonthOilChange_V}  machineCounts={this.state.stMachineCounts} qulcActive={this.state.stQulcActive}  />
            </div>
            <div class="col-12 m-0">
              <Comp_Slider_Box liveTicker={this.state.stLiveTicker} />
            </div>
          </div>
        </div>
      </div>
    </div>

                      {/* End of New Dashboard */}
                   

         
            
         

  






</div>
{/* end of compaign */}
</div>
                {/* end of new acta component */}

{/* <!-- /.content --> */}
</div>
      </div> 
        <Footer/>
        
      </div>)
    }
}
export default Castrol_Dashboard